import TechnicalSanctionOutwards from "./TechnicalSanctionOutwards";

export {TechnicalSanctionOutwards}